module.exports = __webpack_public_path__ + "static/media/qualicorp.51ae7708.svg";